export default __webpack_public_path__ + "images/W8.27b6cba.png";